"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _PriceWatch = _interopRequireDefault(require("./PriceWatch"));
var _default = exports["default"] = _PriceWatch["default"];